import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Divider } from 'antd';
import { setConfig } from './../../../actions/setConfig';
import { getConfig } from './../../../reducers';
import SliderAdmin from './SliderAdmin';
import LoadingPage from '../../../components/LoadingPage';
import PromotionsAdmin from './PromotionsAdmin';
import ServicesAdmin from './ServicesAdmin';
import PlacesAdmin from './PlacesAdmin';

const CONFIGURATIONS_GENERAL_STATE = {
    NONE: "NONE",
    SLIDER: "SLIDER",
    PROMOTIONS: "PROMOTIONS",
    SERVICES: "SERVICES",
    PLACES: "PLACES",
}

class ConfigurationsGeneralAdmin extends Component {
    state = {
        configGeneralState: CONFIGURATIONS_GENERAL_STATE.NONE,
    }
    
    //SLIDER
    onEditSlider = () => {
        this.setState(function(prevState, props) {
            return { configGeneralState: CONFIGURATIONS_GENERAL_STATE.SLIDER }
        })
    }

    onExitSlider = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.NONE })
    }

    //PROMOTIONS
    onEditPromotions = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.PROMOTIONS });
    }

    onExitPromotions = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.NONE });
    }

    //SERVICES
    onEditServices = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.SERVICES });
    }

    onExitServices = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.NONE });
    }

    //PLACES
    onEditPlaces = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.PLACES });
    }

    onExitPlaces = () => {
        this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.NONE });
    }

    renderComponentsState = (state) => {
        switch(state) {
            case CONFIGURATIONS_GENERAL_STATE.NONE: {
                return (<div>
                    <Button onClick={this.onEditSlider}>Slider principal</Button>
                    <Divider />
                    <Button onClick={this.onEditPromotions}>Promociones</Button>
                    <Divider />
                    <Button onClick={this.onEditServices}>Servicios</Button>
                    <Divider />
                    <Button onClick={this.onEditPlaces}>Lugares</Button>
                </div>);
            }

            case CONFIGURATIONS_GENERAL_STATE.SLIDER: {
                return (<div>
                    <SliderAdmin onExitSlider={this.onExitSlider}/>
                </div>);
            }

            case CONFIGURATIONS_GENERAL_STATE.PROMOTIONS: {
                return (<div>
                    <PromotionsAdmin onExitPromotions={this.onExitPromotions}/>
                </div>);
            }

            case CONFIGURATIONS_GENERAL_STATE.SERVICES: {
                return (<div>
                    <ServicesAdmin onExitServices={this.onExitServices}/>
                </div>);
            }

            case CONFIGURATIONS_GENERAL_STATE.PLACES: {
                return (<div>
                    <PlacesAdmin onExitPlaces={this.onExitPlaces}/>
                </div>);
            }

            default: {
                return (<div>
                    <Button onClick={() => this.setState({ configGeneralState: CONFIGURATIONS_GENERAL_STATE.NONE })}>Inicio</Button>
                </div>);
            }
        }
    }

    loadData = () => {
        this.props.setConfig();
        return <LoadingPage />;
    }

    render() {
        return (
            <div>
                {
                    this.props.config ?
                        this.renderComponentsState(this.state.configGeneralState)
                        :
                        this.loadData()
                }
            </div>
        );
    }
}

ConfigurationsGeneralAdmin.propTypes = {
    setConfig: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setConfig: value => dispatch(setConfig(value)),
});

const mapStateToProps = state => ({
    config: getConfig(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ConfigurationsGeneralAdmin));